/**
 * <vb-length-option> — "Standard length / Custom length" for trousers.
 *
 * Visibility of the panel is handled in CSS so it is correct before this runs.
 * This only manages the disabled state, because a hidden but enabled field
 * would still be submitted with the cart form, and associates the fields with
 * the product form (they live outside it in Horizon).
 */
class VbLengthOption extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('.vb-len__panel');
    this.fields = Array.from(this.querySelectorAll('.vb-len__input'));
    this.custom = this.querySelector('.vb-len__radio--custom');
    if (!this.panel || !this.custom) return;

    this.sync = this.sync.bind(this);
    this.attach = this.attach.bind(this);

    this.querySelectorAll('.vb-len__radio').forEach((radio) => {
      radio.addEventListener('change', this.sync);
    });

    this.sync(null);
    this.attach();

    // The variant picker re-renders on selection, which can replace the form.
    this.observer = new MutationObserver(this.attach);
    this.observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  sync(event) {
    const on = this.custom.checked;
    this.panel.hidden = !on;
    this.fields.forEach((field) => {
      field.disabled = !on;
    });
    const [main] = this.fields;
    if (main) {
      main.required = on && this.dataset.required === 'true';
      if (on && event) main.focus({ preventScroll: true });
    }
  }

  attach() {
    const scope = this.closest('.shopify-section') || document;
    const form = scope.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    // form.id would return the <input name="id"> control, since form controls
    // shadow properties on the form element. Read the attribute instead.
    const formId = form.getAttribute('id');
    if (!formId) return;
    this.fields.forEach((field) => {
      if (field.getAttribute('form') !== formId) field.setAttribute('form', formId);
    });
  }
}

if (!customElements.get('vb-length-option')) {
  customElements.define('vb-length-option', VbLengthOption);
}
